/* src/app/admin-dashboard/employees-global/employees-global.component.css */
.eg-page {
  padding: 16px 20px;
}
.eg-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 12px;
}
.eg-head h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.eg-sub {
  color: #888;
  font-size: 13px;
}
.eg-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  padding: 40px;
}
.eg-body {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
.eg-left {
  width: 380px;
  flex: 0 0 380px;
}
.eg-search {
  width: 100%;
}
.eg-search .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.eg-count {
  font-size: 12px;
  color: #999;
  margin: 2px 0 8px;
}
.eg-list {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  max-height: 70vh;
  overflow-y: auto;
  background: #fff;
}
.eg-item {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 0 8px;
  width: 100%;
  text-align: left;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
  padding: 8px 12px;
  cursor: pointer;
}
.eg-item:hover {
  background: #f7f9fc;
}
.eg-item.on {
  background: #e8f0fe;
}
.eg-item-name {
  font-size: 13px;
  font-weight: 600;
  color: #222;
}
.eg-item-email {
  grid-column: 1;
  font-size: 12px;
  color: #888;
}
.eg-item-badge {
  grid-row: 1 / span 2;
  align-self: center;
  font-size: 11px;
  color: #777;
  background: #eee;
  border-radius: 10px;
  padding: 2px 8px;
  white-space: nowrap;
}
.eg-item-badge.multi {
  background: #fff4e5;
  color: #a15c00;
  font-weight: 600;
}
.eg-more,
.eg-empty {
  padding: 12px;
  font-size: 12px;
  color: #999;
  text-align: center;
  font-style: italic;
}
.eg-right {
  flex: 1 1 auto;
  min-width: 0;
}
.eg-placeholder {
  color: #999;
  font-style: italic;
  padding: 40px;
  text-align: center;
  border: 1px dashed #ddd;
  border-radius: 8px;
}
.eg-detail-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 14px;
  flex-wrap: wrap;
  gap: 10px;
}
.eg-detail-name {
  font-size: 17px;
  font-weight: 600;
}
.eg-detail-email {
  font-size: 13px;
  color: #888;
}
.eg-detail-meta {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.eg-chip {
  font-size: 11px;
  background: #eee;
  color: #777;
  border-radius: 10px;
  padding: 2px 10px;
}
.eg-chip.ok {
  background: #e6f4ea;
  color: #1e7e34;
}
.eg-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.eg-table th,
.eg-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
}
.eg-table th {
  color: #666;
  font-weight: 600;
}
.eg-status {
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 11px;
  background: #fdecea;
  color: #b3261e;
}
.eg-status.on {
  background: #e6f4ea;
  color: #1e7e34;
}
.eg-empty {
  color: #999;
  text-align: center;
  font-style: italic;
}
.eg-actions {
  white-space: nowrap;
  text-align: right;
}
@media (max-width: 900px) {
  .eg-body {
    flex-direction: column;
  }
  .eg-left {
    width: 100%;
    flex-basis: auto;
  }
}
/*# sourceMappingURL=employees-global.component.css.map */
